// extracted by mini-css-extract-plugin
module.exports = {"vote-tools-wrapper":"styles_vote-tools-wrapper__275q7"};